<template>
  <div class="to-login-dialog u-flex u-row-center" v-if="showLoginDialog">
    <div class="login-confirm-wrapper">
      <div class="login-content">
        <div class="tip">您未登录，请前往登录</div>
        <el-button class="btn" type="primary" @click="turnToLoginPage">立即登录</el-button>
      </div>
      <div class="close" @click="close">
        <span class="close-icon iconfont icon-guanbi"></span>
      </div>
    </div>
  </div>
</template>

<script>
// import store from '@/store'
import router from '@/router'

import { mapGetters, mapMutations } from 'vuex'
export default {
  computed: {
    ...mapGetters(['showLoginDialog'])
  },
  methods: {
    ...mapMutations(['SET_LOGIN_DIALOG']),
    turnToLoginPage() {
      // store.dispatch('FedLogOut').then(() => {
      if (router.currentRoute.fullPath !== '/login') {
        window.sessionStorage.setItem('urlAfterLogin', window.location.href) // 记下当前在哪个页面，登录状态失效后重新登录，就跳转到这个页面来
      }
      // return Promise.reject(new Error('未授权'))
      // })
      router.replace('/login')
      this.SET_LOGIN_DIALOG(false)
    },
    close() {
      this.SET_LOGIN_DIALOG(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.to-login-dialog {
  background: rgba($color: #000000, $alpha: 0.2);
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  .login-confirm-wrapper {
    margin-bottom: 200px;
    position: relative;
    width: 425px;
    height: 425px;
    background-image: url('../assets/img/login-confirm-bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .login-content {
      text-align: center;
      position: absolute;
      top: 75%;
      left: 30%;
      .tip {
        font-size: 16px;
        margin-bottom: 20px;
      }
      .btn {
        text-align: center;
        width: 218px;
        height: 38px;
        border-radius: 19px;
      }
    }
    .close {
      cursor: pointer;
      position: absolute;
      bottom: -7%;
      left: 52%;
      .close-icon {
        font-size: 24px;
        color: #fff;
      }
    }
  }
}
</style>
